// 带输入框的 checkbox
export const InputMultiSelection = 100302

// 普通的地址组件相关id
export const addressProvince = 100120
export const addressCity = 100121
export const addressCountry = 100122
export const addressInput = 100123

// 用户信息组件 工作所在地相关id
export const userInfoAddressProvince = 100174
export const userInfoAddressCity = 100175

// 用户信息组件。
export const userInfoCompany = 100172
export const userInfoRealName = 100170
export const userInfoMail = 100171
export const userInfoIndustry = 100470
export const userInfoPosition = 100471
export const userInfoDepartmentName = 100173
export const userInfoTeamSize = 100472
export const userInfoAddress = [userInfoAddressProvince, userInfoAddressCity]
export const userInfoWorkYear = 100473
export const userInfoDirectionInterest = 100370
export const userInfoInternalTraining = 100270

// input 所对应的 type。
export const inputTypeMappingGraph = {
  common: [100101, userInfoRealName, userInfoRealName, userInfoDepartmentName],
  number: [100110],
  email: [100103, userInfoMail],
  phone: [100104, 100111],
  phone_captcha: [100111],
  date: [100901],
  common_address: [addressProvince, addressCity, addressCountry, addressInput],
  user_info_address: [...userInfoAddress],
  is_company_tianyancha: (type, subType) => {
    if ((type === 100100 && subType === 100130) || subType === userInfoCompany) {
      return true
    }
    return false
  }
}
